import * as uuid from 'uuid';

export function generateUuidWithPrefix(prefix: string): string {
  return prefix + '-' + uuid.v4();
}

export function generateUuid(): string {
  return uuid.v4();
}

export function displayShortUuid(id: string): string {
  if (id) {
    return id.substring(0, 8).toUpperCase();
  }
  return id;
}

export function isValidUuid(id: string): boolean {
  return uuid.validate(id);
}
